import JWTService from './jwt.service'

const user = () => {
    return JSON.parse(JWTService.getToken())
}

export default user